import firebase from 'firebase'
import firestore from 'firebase/firestore'

var config = {
    apiKey: "AIzaSyACtFGign4apS4G_uFJGRGGh8xTmxoZXTg",
    authDomain: "hobby-tracker-a9788.firebaseapp.com",
    databaseURL: "https://hobby-tracker-a9788.firebaseio.com",
    projectId: "hobby-tracker-a9788",
    storageBucket: "hobby-tracker-a9788.appspot.com",
    messagingSenderId: "1016837754769"
  };
const firebaseApp = firebase.initializeApp(config);

// export firestore database
export default firebaseApp.firestore()
